const placeholder = require('../../data/placeHolderCopy.js').default;

module.exports = {
  getLabel: function getLabel(path) {
    const keys = path.split('.');
    let content = this;
    let result = '';

    for (let i = 0; i < keys.length; i++) {
      if (keys[i] in content) {
        content = content[keys[i]];
      } else {
        result = '';
        console.warn(`CONTENT ISSUE: Missing label ${path}`);
        break;
      }
    }

    if (content !== this) {
      result = content;
    }

    return result;
  },
  blades: window.offers && window.offers.blades
    ? window.offers.blades : placeholder.blades,
  offersZipGateData: window.offers && window.offers.offersZipGateData
    ? window.offers.offersZipGateData : placeholder.offersZipGateData,
  promotional: window.offers && window.offers.promotional
    ? window.offers.promotional : placeholder.promotional,
  labels: window.offers && window.offers.labels
    ? window.offers.labels : placeholder.labels,
  ctas: window.offers && window.offers.CTAs
    ? window.offers.CTAs : placeholder.CTAs,
  APR: window.offers && window.offers.APR
    ? window.offers.APR : placeholder.APR,
  config: window.offers && window.offers.config
    ? window.offers.config : placeholder.config,
  educationalContent: window.offers && window.offers.educationalContent
    ? window.offers.educationalContent : placeholder.educationalContent,
  stockPhoto: window.offers && window.offers.stockPhoto
    ? window.offers.stockPhoto : placeholder.stockPhoto,
  filters: window.offers && window.offers.filters
    ? window.offers.filters : placeholder.filters,
  disclaimer: window.offers && window.offers.Disclaimer
    ? window.offers.Disclaimer : placeholder.disclaimer,
  banners: window.offers && window.offers.banners
    ? window.offers.banners : placeholder.banners,
  offersAPIBaseURL: window.offers && window.offers.offersAPIBaseURL
    ? window.offers.offersAPIBaseURL : placeholder.offersAPIBaseURL,
  specialTypes: window.offers && window.offers.specials
    ? window.offers.specials : placeholder.specials,
  cookies: window.offers && window.offers.cookies
    ? window.offers.cookies : placeholder.cookies,
  title: window.offers && window.offers.title
    ? window.offers.title : placeholder.title,
};
